import { render, staticRenderFns } from "./PromoteWithdrawalRecord.vue?vue&type=template&id=f059041e&scoped=true"
import script from "./PromoteWithdrawalRecord.vue?vue&type=script&lang=js"
export * from "./PromoteWithdrawalRecord.vue?vue&type=script&lang=js"
import style0 from "./PromoteWithdrawalRecord.vue?vue&type=style&index=0&id=f059041e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f059041e",
  null
  
)

export default component.exports